import { _cleanSearchArguments } from './_cleanSearchArguments';

export function indexOf(...args) {
  const { string, query } = _cleanSearchArguments.apply(null, args);
  return string.indexOf(query);
}
